'use strict';

var _a;

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.fontLineHeight =
  exports.themeFonts =
  exports.themeAdaptiveFonts =
  exports.themeStaticFonts =
  exports.baseFontSettings =
    void 0;

var components_1 = require('./components');

exports.baseFontSettings =
  "\n    font-family: Rostelecom Basis;\n    font-style: normal;\n    font-feature-settings: 'tnum' on, 'lnum' on;\n";
exports.themeStaticFonts = {
  accentL:
    ' \n    ' +
    exports.baseFontSettings +
    '\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 32px;\n  ',
  accentM:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 24px;\n  ',
  accentS:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n  ',
  accentXS:
    '\n    ' + exports.baseFontSettings + '\n    font-size: 12px;\n    line-height: 16px;\n  ',
  bodyL:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 24px;\n  ',
  bodyM:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 20px;\n  ',
  caption:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n  ',
  description:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: normal;\n    font-size: 11px;\n    line-height: 16px;\n  ',
  mega:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: bold;\n    font-size: 42px;\n    line-height: 44px;\n  ',
  h1:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: bold;\n    font-size: 28px;\n    line-height: 32px;\n  ',
  h2:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: bold;\n    font-size: 22px;\n    line-height: 24px;\n  ',
  h3:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 20px;\n  ',
  h4:
    '\n    ' +
    exports.baseFontSettings +
    '\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 20px;\n  ',
};

exports.themeAdaptiveFonts =
  ((_a = {}),
  (_a[components_1.BREAKPOINTS.mobile_small] = {
    accentL:
      '\n      ' +
      exports.themeStaticFonts.accentL +
      '\n      font-size: 20px;\n      line-height: 28px;\n    ',
    accentM:
      '\n      ' +
      exports.themeStaticFonts.accentM +
      '\n      font-size: 14px;\n      line-height: 20px;\n    ',
    accentS: '\n      ' + exports.themeStaticFonts.accentS + '\n    ',
    accentXS: '\n      ' + exports.themeStaticFonts.accentXS + '\n      font-size: 13px;\n    ',
    bodyL:
      '\n      ' +
      exports.themeStaticFonts.bodyL +
      '\n      font-size: 14px;\n      line-height: 20px;\n    ',
    bodyM:
      '\n      ' +
      exports.themeStaticFonts.bodyM +
      '\n      font-size: 13px;\n      line-height: 20px;\n    ',
    caption: '\n      ' + exports.themeStaticFonts.caption + '\n    ',
    description:
      '\n      ' +
      exports.themeStaticFonts.description +
      '\n      font-size: 10px;\n      line-height: 12px;\n      letter-spacing: 0.4px;\n    ',
    mega:
      '\n      ' +
      exports.themeStaticFonts.mega +
      '\n      font-size: 24px;\n      line-height: 32px;\n    ',
    h1:
      '\n      ' +
      exports.themeStaticFonts.h1 +
      '\n      font-size: 18px;\n      line-height: 24px;\n    ',
    h2:
      '\n      ' +
      exports.themeStaticFonts.h2 +
      '\n      font-size: 16px;\n      line-height: 20px;\n    ',
    h3: '\n      ' + exports.themeStaticFonts.h3 + '\n      font-size: 14px;\n    ',
    h4: '\n      ' + exports.themeStaticFonts.h4 + '\n      font-size: 13px;\n    ',
  }),
  (_a[components_1.BREAKPOINTS.mobile_large] = {
    accentL: '\n      ' + exports.themeStaticFonts.accentL + '\n    ',
    accentM: '\n      ' + exports.themeStaticFonts.accentM + '\n    ',
    accentS: '\n      ' + exports.themeStaticFonts.accentS + '\n    ',
    accentXS: '\n      ' + exports.themeStaticFonts.accentXS + '\n    ',
    bodyL: '\n      ' + exports.themeStaticFonts.bodyL + '\n    ',
    bodyM: '\n      ' + exports.themeStaticFonts.bodyM + '\n    ',
    caption: '\n      ' + exports.themeStaticFonts.caption + '\n    ',
    description:
      '\n      ' +
      exports.themeStaticFonts.description +
      '\n      font-size: 11px;\n      line-height: 16px;\n      letter-spacing: 0.2px;\n    ',
    mega:
      '\n      ' +
      exports.themeStaticFonts.mega +
      '\n      font-size: 32px;\n      line-height: 40px;\n    ',
    h1: '\n      ' + exports.themeStaticFonts.h1 + '\n      font-size: 24px;\n    ',
    h2: '\n      ' + exports.themeStaticFonts.h2 + '\n      font-size: 20px;\n    ',
    h3: '\n      ' + exports.themeStaticFonts.h3 + '\n    ',
    h4: '\n      ' + exports.themeStaticFonts.h4 + '\n    ',
  }),
  (_a[components_1.BREAKPOINTS.desktop_small] = {
    accentL: ' \n      ' + exports.themeStaticFonts.accentL + '\n    ',
    accentM: '\n      ' + exports.themeStaticFonts.accentM + '\n    ',
    accentS: '\n      ' + exports.themeStaticFonts.accentS + '\n    ',
    accentXS: '\n      ' + exports.themeStaticFonts.accentXS + '\n    ',
    bodyL: '\n      ' + exports.themeStaticFonts.bodyL + '\n    ',
    bodyM: '\n      ' + exports.themeStaticFonts.bodyM + '\n    ',
    caption: '\n      ' + exports.themeStaticFonts.caption + '\n    ',
    description: '\n      ' + exports.themeStaticFonts.description + '\n    ',
    mega: '\n      ' + exports.themeStaticFonts.mega + '\n    ',
    h1: '\n      ' + exports.themeStaticFonts.h1 + '\n    ',
    h2: '\n      ' + exports.themeStaticFonts.h2 + '\n    ',
    h3: '\n      ' + exports.themeStaticFonts.h3 + '\n    ',
    h4: '\n      ' + exports.themeStaticFonts.h4 + '\n    ',
  }),
  _a);
exports.themeFonts = {
  static: exports.themeStaticFonts,
  adaptive: exports.themeAdaptiveFonts,
};

exports.fontLineHeight = {
  accentL: 32,
  accentM: 24,
  accentS: 20,
  accentXS: 16,
  bodyL: 24,
  bodyM: 20,
  caption: 16,
  description: 16,
  mega: 44,
  h1: 32,
  h2: 24,
  h3: 20,
  h4: 20,
};
